import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsLegacyNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const legacyNumberStyles: ProductDetailsLegacyNumberStyles = {
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
        `,
    },
};

const styles = legacyNumberStyles;

const ProductDetailsLegacyNumber: React.FC<Props> = ({ product }) => {
    if (!product.detail?.sku) {
        return null;
    }

    return (
        <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsLegacyNumber">
            <Typography {...styles.labelText}>{translate("Legacy #")}</Typography>
            {product.detail?.sku}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsLegacyNumber),
    definition: {
        displayName: "Legacy Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
